<template>
  <article class="">
    <div class="message-header">
      {{ title }}
      <button @click="clicked" class="delete"></button>
    </div>
    <div class="message-body">
      <slot></slot>
    </div>
  </article>
</template>

<script>
export default {
  name: 'RemovableCard',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    clicked() {
      this.$emit('cardDelete');
    },
  },
};
</script>

<style lang="scss" scoped>

article {
  background-color: $form-subitem;
}

</style>
